<template>
    <div class="d-flex flex-column mt-2 card p-2">
        <div class="d-flex py-2">
            <span><i class="fas fa-user font-size-sm"></i></span><span class="ms-2 shimmer-loading"></span>
        </div>
        <div class="d-flex py-2">
            <span><i class="fas fa-address-book font-size-sm"></i></span><span class="ms-2 shimmer-loading"></span>
        </div>
        <div class="d-flex py-2">
            <span><i class="fas fa-mobile font-size-sm"></i></span><span class="ms-2 shimmer-loading"></span>
        </div>
        <div class="d-flex py-2">
            <span><i class="fas fa-at font-size-sm"></i></span><span class="ms-2 shimmer-loading"></span>
        </div>
    </div>
</template>
